var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipsis4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "5px",
    viewBox: "0 0 29 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login-/-Account-Create-1024px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#BDC6CB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.1333333,
    cy: 2.48888889,
    r: 2.48888889
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 2.48888889,
    cy: 2.48888889,
    r: 2.48888889
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 25.9555556,
    cy: 2.48888889,
    r: 2.48888889
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 10.3111111,
    cy: 2.48888889,
    r: 2.48888889
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipsis4);
export default __webpack_public_path__ + "static/media/Elipsis4.f2873992768f2806ae90c958e7a1f611.svg";
export { ForwardRef as ReactComponent };